export interface ClientMetadata {
  browser?: string;
  os?: string;
  operatingSystem?: string;
  device?: string;
  screenWidth?: number;
  screenHeight?: number;
  currentDomain?: string;
  currentURL?: string;
  userAgent?: string;
  language?: string;
  timezone?: string;
}

export function buildClientMetadata(hostUrl?: string): ClientMetadata {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const win = typeof window !== 'undefined' ? window : undefined;
  const userAgent = nav?.userAgent;
  const os = userAgent ? detectOS(userAgent) : undefined;
  let currentDomain: string | undefined;
  if (hostUrl) {
    try {
      currentDomain = new URL(hostUrl).hostname;
    } catch {
      currentDomain = undefined;
    }
  }
  return {
    browser: userAgent ? detectBrowser(userAgent) : undefined,
    os,
    operatingSystem: os,
    device: userAgent ? detectDevice(userAgent) : undefined,
    screenWidth: win?.screen?.width,
    screenHeight: win?.screen?.height,
    currentDomain,
    currentURL: hostUrl,
    userAgent,
    language: nav?.language,
    timezone: resolveTimezone(),
  };
}

function detectBrowser(ua: string): string {
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('OPR') || ua.includes('Opera')) return 'Opera';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari')) return 'Safari';
  return 'Other';
}

function detectOS(ua: string): string {
  if (ua.includes('Windows')) return 'Windows';
  if (ua.includes('Android')) return 'Android';
  if (/iPhone|iPad|iPod|like Mac/.test(ua)) return 'iOS';
  if (ua.includes('Mac')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  return 'Other';
}

function detectDevice(ua: string): string {
  if (/iPad|Tablet/.test(ua)) return 'tablet';
  if (/Mobi|Android|iPhone|iPod/.test(ua)) return 'mobile';
  return 'desktop';
}

function resolveTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}
